import { useEffect } from "react";
import { useStores } from "../../../use-stores";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, useTheme } from "@mui/material";
import { observer } from "mobx-react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ProductVariantImageList from "./ProductVariantImageList";
import { useNotification } from "../../../../../utils/NotificationsContext";
const ProductVariantsList = () => {
  const { productStore } = useStores();
  const location = useLocation();
  const { showError } = useNotification();

  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("product-id") || 0;
  const theme = useTheme();
  const navigate = useNavigate();
  useEffect(() => {
    if (productId) {
      if (productId === "0") {
        showError("Error occurred", "No product found for id 0.");
      } else {
        productStore
          .getProductDetailsById(Number(productId))
          .catch((err) =>
            showError(
              "Error occurred",
              err?.response?.data?.message || "Something went wrong!"
            )
          );
      }
    } else {
      productStore.clearProductDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, productStore]);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          cursor: "pointer",
          color: theme.palette.customColors.greyTextColor,
          mb: 2,
          mt: 4,
          maxWidth: "3.75rem",
          paddingLeft: 3.5,
          paddingRight: 2,
          "&:hover, &:active": {
            color: theme.palette.customColors.greyTextColor,
          },
        }}
        onClick={() => {
          navigate(`/products/${productId}`);
        }}
      >
        <ArrowBackIcon sx={{ fontSize: "1rem" }} />
        <span style={{ fontSize: "0.875rem", fontWeight: "600" }}>Back</span>
      </Box>
      {productStore.productDetails.variants?.map((variant) => (
        <ProductVariantImageList variant={variant} />
      ))}
    </Box>
  );
};

export default observer(ProductVariantsList);
